// AlphaListViewCompact.jsx

import React from 'react';

import AlphaListView from './AlphaListView';

/**
 * Compact alphabetized list for constrained surfaces.
 * Reuses AlphaListView without the A–Z rail.
 *
 * @returns {ReactNode}
 */
const AlphaListViewCompact = React.memo(({
  enforceExplicitProperties = false,
  view,
  typeDef,
  nodes = [],
  language = 'en',
  onItemClick = null,
}) => (
  <AlphaListView
    enforceExplicitProperties={enforceExplicitProperties}
    view={view}
    typeDef={typeDef}
    nodes={nodes}
    language={language}
    onItemClick={onItemClick}
    showIndex={false}
  />
));

AlphaListViewCompact.displayName = 'AlphaListViewCompact';

export default AlphaListViewCompact;
